import { PictureBe } from '../../image-library/shared/image-model';
import { AttributeListBE, MaterialCompositionBE } from '../../shared/attribute-list.model';
export class PackagingMaterialListBE {
  CategoryDescription: string;
  Description: string;
  Height: number;
  Id: number;
  Length: number;
  MHNo: string;
  Status: string;
  PackagingType: string;
  Weight: number;
  Width: number;
}

export class PackagingMaterialBE {
  Id: number = -1;
  StatusId = 1;
  StatusDescription = '';
  Version = 0;
  MHNo = '';
  Description = '';
  AlternativeId = '';
  OuterLength = 0;
  OuterWidth = 0;
  OuterHeight = 0;
  Weight = 0;
  InnerLength = 0;
  InnerHeight = 0;
  InnerWidth = 0;
  MaxWeightOnTop = 0;
  MaxWeightInside = 0;
  Colour = '';
  SuitableFor = '';
  InitialCreatorUserId = '';
  InitialCreatorUserName = '';
  InitialCreatorUserDepartment = '';
  InitialCreatorEmail='';
  ResponsibleUserId = '';
  ResponsibleUserName = '';
  ResponsibleUserDepartment = '';
  ResponsibleEmail='';
  PackagingOwnerId = 1;
  PackagingOwnerDescription = '';
  MaterialTypeId = 1;
  MaterialTypeDescription = '';
  PackagingTypeId = 1;
  PackagingTypeDescription = '';
  Stackable = false;
  WashingIndicator = false;
  BreakdownIndicator = false;
  PoolIndicator = false;
  RegionId = 1;
  RegionDescription = '';
  ReturnableId = 1;
  ReturnableDescription = '';
  MaterialClassificationId = 1;
  ClassificationDescription = '';
  StorageConditionId = 1;
  StorageCondDescription = '';
  ReplacingMaterialId: number = null;
  ReplacingMaterialMHNO = '';
  ReplacedByMaterialId: number = null;
  ReplacedByMaterialMHNO = '';
  Remarks = '';
  CreatedDate: Date = new Date(Date.now());
  Material = '';
  Price = 0;
  WeightChanged = false;
  EstimatedkgCO2Weight = 0;
  ChangedDate: Date;

  Pictures: Array<PictureBe> = [];
  Suppliers: Array<MaterialSupplierBE> = [];
  ConsumingAreas: Array<AttributeListBE> = [];
  Dispatchers: Array<AttributeListBE> = [];
  MainStores: Array<AttributeListBE> = [];
  Receivers: Array<AttributeListBE> = [];
    WashingSuppliers: Array<AttributeListBE> = [];
    isInitialCreator: boolean = false;
    isResponsible: boolean = false;
    MaterialCompositions: Array<MaterialCompositionBE> = [];
}

export class MaterialSupplierBE {
  Id: number;
  SupplierId: number;
  SupplierNo: string;
  SupplierName: string;
}

export class MaterialSearchList {
  Id: number;
  MHNo: string;
  Description: string;
  Weight: number;
  Status: string;
  PackagingOwner: string;
  Length: number;
  Width: number;
  Height: number;
  FirstImage: Uint8Array[];
  Label: string;
}



// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/app/packaging-material/shared/packaging-material.model.ts